import type { AuthData, ThirdPartyRegister, ThirdPartySMS } from '@/models/interface/auth';
import { ApiFactory, type ApiDataResponse } from '@/utils/api';

export class AuthService extends ApiFactory {
  constructor() {
    super('Auth');
  }

  /** Google驗證 */
  googleVerify(idToken: string): Promise<ApiDataResponse<AuthData>> {
    return super.post(`GoogleVerify`, { idToken });
  }

  /** Meta驗證 */
  metaVerify(accessToken: string): Promise<ApiDataResponse<AuthData>> {
    return super.post(`FacebookVerify`, { accessToken });
  }

  /**
   * Line驗證
   * @param token
   * @param isIdToken accessToken false, idToken true
   * @returns
   */
  lineVerify(token: string): Promise<ApiDataResponse<AuthData>> {
    return super.post(`LineVerify`, {
      token,
      isIdToken: false
    });
  }

  /**
   * Apple驗證
   * @param token
   * @param isIdToken accessToken false, idToken true
   * @returns
   */
  appleVerify(token: string): Promise<ApiDataResponse<AuthData>> {
    return super.post(`AppleVerify`, {
      token,
      isIdToken: false
    });
  }

  thirdPartySMSVerification(data: ThirdPartySMS): Promise<ApiDataResponse<string>> {
    return super.post(`ThirdPartySMSVerification`, data);
  }

  thirdPartyRegister(data: ThirdPartyRegister): Promise<ApiDataResponse<string>> {
    return super.post(`ThirdPartyRegister`, data);
  }
}
